<script setup lang="ts">
interface Props {
  vertical?: boolean
  variant?: 'default' | 'light' | 'dark'
}

const props = withDefaults(defineProps<Props>(), {
  vertical: false,
  variant: 'default',
})

function getBgClass(): Record<string, boolean> {
  return {
    'bg-neutral-light-1': props.variant === 'default',
    'bg-neutral-light-2': props.variant === 'light',
    'bg-neutral-dark-9': props.variant === 'dark',
  }
}
</script>

<template>
  <div
    v-if="vertical"
    class="w-0.25"
    :class="getBgClass()"
  >
    &nbsp;
  </div>
  <div
    v-else
    class="h-0.25"
    :class="getBgClass()"
  />
</template>
